import React from 'react';
import './DashboardFilter.scss';

const DashboardFilter = ({ onSearch, onSortChange, onOrderChange, onRatingSortDirectionChange }) => {
  return (
    <div className="filters">

      <div className="filters__title">
        <p>Filter & Sort</p>
      </div>

      <div className="filters__content">

        <div className="filters__controls">
          <label htmlFor="search">Search</label>
          <input
            type="text"
            name="saerch"
            placeholder="Search posts..."
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

        <div className="filters__controls">
          <label>Rating Sort Direction: </label>
          <select onChange={(e) => onRatingSortDirectionChange(e.target.value)}>
            <option value="">Select Rating Sort</option>
            <option value="positive">Positive</option>
            <option value="negative">Negative</option>
          </select>
        </div>

        <div className="filters__controls">
          <label>Sort by: </label>
          <select onChange={(e) => onSortChange(e.target.value)}>
            <option value="publishingDate">Publishing Date</option>
            <option value="postTitle">Post Title</option>
          </select>
        </div>
        {/* <div className="filters__controls">
          <label>Order: </label>
          <select onChange={(e) => onOrderChange(e.target.value)}>
            <option value="descending">Descending</option>
            <option value="ascending">Ascending</option>
          </select>
        </div> */}
      </div>
    </div>
  );
};

export default DashboardFilter;
